import _ from 'lodash';

import * as BECaller from '../../util/apiCaller';
import { setError, setSuccessMessage } from '../App/ErrorsActions';
import { AUTH_USER } from '../Auth/AuthActions';
import urlHelper from '../../util/url';
import { saveCsv } from '../../util/users';
import { trackUsersExport } from '../../util/mixpanel';

export const USERS = 'USERS_USERS',
  ACCESS = 'USERS_ACCESS',
  LOADING = 'USERS_LOADING';

let options = {};

export function error(err) {
  return setError(err);
}

export function exportCsv(opt = {}) {
  if (!_.isEmpty(opt)) {
    options = opt;
  }

  return dispatch => {
    dispatch({
      type: LOADING,
      val: true
    });

    let url = 'users';
    url += urlHelper.buildQuery(options);

    BECaller.api(url, 'get').then(
      data => {
        try {
          saveCsv(data.results);

          trackUsersExport();

          dispatch(setSuccessMessage('Users export completed.'));
        } catch (err) {
          dispatch(setError('Users export failed.'));
        }
        dispatch({
          type: LOADING,
          val: false
        });
      },
      err => {
        dispatch(setError(err));
      }
    );
  };
}

export function getUsers(opt = {}) {
  if (!_.isEmpty(opt)) {
    options = opt;
  }

  return dispatch => {
    dispatch({
      type: LOADING,
      val: true
    });

    let url = 'users';
    url += urlHelper.buildQuery(options);

    BECaller.api(url, 'get').then(
      data => {
        dispatch({
          type: USERS,
          data
        });
      },
      err => {
        dispatch(setError(err));
      }
    );
  };
}

export function transferOwnership(id) {
  return dispatch => {
    dispatch({
      type: LOADING,
      val: true
    });

    BECaller.api('users/transfer', 'post', { userId: id }).then(
      () => {
        dispatch(setSuccessMessage('The onwership of the project has been transfered successfully.'));
        return dispatch(getUsers());
      },
      err => {
        dispatch(setError(err));
        dispatch({
          type: LOADING,
          val: false
        });
      }
    );
  };
}

export function resendInvitation(id) {
  return dispatch => {
    dispatch({
      type: LOADING,
      val: true
    });

    BECaller.api('users/resend', 'post', { id }).then(
      () => {
        dispatch(
          setSuccessMessage(
            'An invitation email has been sent. Once accepted, the user will be granted access to your account.'
          )
        );
        return dispatch(getUsers());
      },
      err => {
        dispatch(setError(err));
        dispatch({
          type: LOADING,
          val: false
        });
      }
    );
  };
}

export function inviteUser(body) {
  return dispatch => {
    dispatch({
      type: LOADING,
      val: true
    });

    BECaller.api(`users`, 'post', body).then(
      () => {
        dispatch(
          setSuccessMessage(
            'An invitation email has been sent. Once accepted, the user will be granted access to your account.'
          )
        );
        return dispatch(getUsers());
      },
      err => {
        dispatch(setError(err));
        dispatch({
          type: LOADING,
          val: false
        });
      }
    );
  };
}

export function updateUser(body, bulk) {
  return dispatch => {
    dispatch({
      type: LOADING,
      val: true
    });

    BECaller.api(`users${bulk ? '/bulk' : ''}`, 'put', body).then(
      () => {
        // dispatch(setSuccessMessage("An invitation email has been sent. Once accepted, the user will be granted access to your account."));
        return dispatch(getUsers());
      },
      err => {
        dispatch(setError(err));
        dispatch({
          type: LOADING,
          val: false
        });
      }
    );
  };
}

export function deleteUser(id) {
  return dispatch => {
    BECaller.api(`users`, 'delete', { id }).then(
      () => {
        return dispatch(getUsers());
      },
      err => {
        dispatch(setError(err));
      }
    );
  };
}

export function revokeRequest(redirect) {
  return (dispatch, getState) => {
    return BECaller.api(`account/revokerequest?redirect=${redirect}`, 'get').then(
      data => {
        dispatch({
          type: ACCESS,
          val: false
        });

        if (data) {
          dispatch({
            type: AUTH_USER,
            payload: {
              ...getState().auth.user,
              ...data,
              loaded: true
            }
          });
        }
      },
      err => {
        dispatch(setError(err));
      }
    );
  };
}

export function rejectRequest(id) {
  return dispatch => {
    BECaller.api('account/rejectrequest', 'delete', { id }).then(
      () => {
        return dispatch(getUsers());
      },
      err => {
        dispatch(setError(err));
      }
    );
  };
}
